import { apiDelete, apiGet, apiPost, apiPostForm, apiPut } from './api';

export function listPorts() {
  return apiGet('/api/ports');
}

export function addPort(payload) {
  return apiPost('/api/ports', payload);
}

export function updatePort(id, payload) {
  return apiPut(`/api/ports/${id}`, payload);
}

export function deletePorts(ids) {
  return apiDelete('/api/ports', { ids });
}

export function importPorts(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/api/ports/import', formData);
}

export function verifyImportPorts(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/api/ports/import/verify', formData);
}
